import React, { useEffect } from 'react'
import { Field, change } from 'redux-form'
import { getInsuranceFromRPAServices } from '../../../../containers/authorised/addOns/other/AddOnsHelperFunctions';
import Alert from '../../../../itrust_common/components/Alert';
import { connect } from 'react-redux';
import { claimFormReset } from '../../../../redux/actions/order/claimFormActions';
import { tabChange } from '../../../../itrust_common/redux/actions/otherActions';
import { AutoCompleteSelect } from '../../../../itrust_common/components/form';
import { getInsuranceType } from '../../../../itrust_common/components/HelperFunctions';
import { visionInsuranceServicesLoad } from '../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceAction';
import { visionInsuranceClaimFormReset } from '../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction';
import RPAInsuranceVerify from '../../../../containers/authorised/addOns/rpa/vision_insurance/eligibilityVerify/RPAInsuranceVerify';

function OrderInsurancePayer(props) {
  const { claimFormData, order, dispatch, activeTab, visionInsuranceConfig, services } = props

  useEffect(() => {
    let storeID = localStorage.getItem('StoreID')
    if (storeID == null) {
      // Store dropdown All selected > load RPA services from order's store_id
      dispatch(visionInsuranceServicesLoad({ store_id: order.store_id, category: "vision_insurance" }))
    }
  }, [])

  const handleOnInsuranceChange = async (data) => {
    const selectedInsuranceType = data?.insuranceType.slice(0, 13) === 'PatientVision' ? 'vision' : 'medical';
    const existingInsuranceType = order.patient_insurance_attributes?.insurance_type.slice(0, 13) === 'PatientVision' ? 'vision' : 'medical';
    const isSameInsuranceType = selectedInsuranceType === existingInsuranceType;
    let showAlert = false;
    let alertText = '';
    if (isSameInsuranceType) {
      if (visionInsuranceConfig?.status && visionInsuranceConfig?.status !== 'inactive' && selectedInsuranceType === 'vision') {
        const selectedInsuranceIsRPA = getInsuranceFromRPAServices(services, data?.insuranceName || order.patient_insurance_attributes?.insurance_name);
        const previousInsuranceIsRPA = getInsuranceFromRPAServices(services, order.patient_insurance_attributes?.insurance_name);
        if (selectedInsuranceIsRPA || previousInsuranceIsRPA) {
          showAlert = true;
          alertText = 'You are changing Vision insurance from or to an RPA Insurance.';
        }
      }
    } else if (!isSameInsuranceType) {
      showAlert = true;
      alertText = 'You are changing insurance from Vision to Medical.';
    }
    if (claimFormData.id && showAlert) {
      try {
        const confirmed = await new Promise((resolve, reject) => {
          Alert.confirm(`Claim form for this order exists. ${alertText} Clicking 'Continue' will delete the existing claim form.`, (res) => {
            if (res) {
              handleAllowClaimDelete(data);
              resolve(true);
            } else {
              reject(false);
            }
          });
        });
        return confirmed;
      } catch {
        return false;
      }
    } else {
      if (!data) {
        // Reset Case
        dispatch(change('orderHeaderForm', 'patient_insurance_id', null));
        dispatch(change('orderHeaderForm', 'patient_insurance_name', null));
      }
      return true;
    }
  };

  const handleAllowClaimDelete = (data) => {
    // const { activeTab } = this.props;
    dispatch(change('orderHeaderForm', `is_destroy_claim_form`, true));
    dispatch(claimFormReset())
    dispatch(visionInsuranceClaimFormReset())
    activeTab === 6 && dispatch(tabChange({ order: 1 }))
    if (!data) {
      // Reset Case
      dispatch(change('orderHeaderForm', 'patient_insurance_id', null));
      dispatch(change('orderHeaderForm', 'patient_insurance_name', null));
    }
  }

  const insuranceOptions = () => {
    const patientAttributes = order.patient_attributes
    let options = []
    const insuranceTypes = ['patient_vision_insurance', 'patient_medical_insurance', 'patient_secondary_insurance', 'patient_tertiary_insurance', 'patient_vision_secondary_insurance', 'patient_vision_tertiary_insurance']
    insuranceTypes.map(insuranceType => {
      if (patientAttributes?.[insuranceType]) {
        options = [...options, { insuranceType: patientAttributes[insuranceType].insurance_type, insuranceName: patientAttributes[insuranceType]?.insurance_name, id: patientAttributes[insuranceType]?.id }]
      }
    })
    return options;
  }

  return (
    <>
      <Field
        name="patient_insurance_id"
        label="Insurance Payer"
        component={AutoCompleteSelect}
        data={insuranceOptions()}
        onSelectChange={(data) => handleOnInsuranceChange(data)}
        onResetVal={() => handleOnInsuranceChange()}
        displayName="patient_insurance_name"
        textField="insuranceName"
        valueField="id"
        hideSearch={true}
        key={order.id}
        wrapperClasses="form-group col-8"
      />

      {visionInsuranceConfig?.visible && <div className='col-4 pl-0'>
        <RPAInsuranceVerify
          selectedInsuranceName={order.patient_insurance_attributes?.insurance_name}
          selectedInsuranceMemberId={order.patient_insurance_attributes?.member_id}
          insuranceType={getInsuranceType(order.patient_insurance_attributes?.insurance_type)}
          orderId={order.id}
          patientId={order.patient_id}
          order={order}
          isOrderView={true}
          wrapperClasses="align-items-center"
        />
      </div>}
    </>
  )
}


const mapStateToProps = (state) => {
  const { organisation: { organisation }, visionInsurance: { services }, order: { order } } = state

  return {
    visionInsuranceConfig:organisation.add_ons_config?.type?.vision_insurance,
    services,
    order,
  }
}

export default connect(mapStateToProps)(OrderInsurancePayer)